export function LoadingDots() {
    return (
        <span className="loading-dots ms-1">
            <span>.</span>
            <span>.</span>
            <span>.</span>

            <style>{`
                .loading-dots span {
                    animation: dot-blink 1.4s infinite both;
                    opacity: 0;
                }
                .loading-dots span:nth-child(2) { animation-delay: 0.2s; }
                .loading-dots span:nth-child(3) { animation-delay: 0.4s; }
                @keyframes dot-blink {
                    0%, 80%, 100% { opacity: 0; }
                    40% { opacity: 1; }
                }
            `}</style>
        </span>
    );
}
